<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link
          :to="{ name: 'EstimatedInsuranceRequiredOutput' }"
          class="back-arrow"
        >
          <v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon>
        </router-link>
      </v-col>
      <v-col cols="12" sm="11">
        <h1>
          Your estate will need to cover
          <span class="secondary-highlighted"
            >R
            {{
              testator.estateCostCalculation.estimatedEstateAdministrativeCosts
                | currency
            }}</span
          >
          in estate administration costs upon your passing
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="8" offset-sm="2">
            <p class="text-center mb-8">
              ...if you do not make provision for this, your assets will get
              sold to cover these costs, which could cause your family a lot of
              stress in a time of grieving.
            </p>

            <p class="mb-0">
              You may have an existing life policy, but if that policy is used
              to cover these estate administration costs, it will mean your
              loved ones receive less value. You might want to consider these
              other options:
            </p>

            <ul>
              <li>
                increase the value of an existing policy to cater for these
                additional costs; or
              </li>
              <li>
                take out a new policy for these costs specifically and let your
                existing policy go to your loved ones
              </li>
            </ul>

            <p v-if="!hasAdvisorFullInsurance" class="mt-8">
              Contact your financial advisor to assist you with the right
              financial services products to make provision for this.
            </p>
          </v-col>
        </v-row>

        <v-row class="text-center">
          <v-col cols="12">
            <GradientButton
              title="RETURN TO DASHBOARD"
              :small="true"
              @gradientButtonClicked="$router.push('/overview')"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
  </v-container>
</template>

<script>
  import { REQUEST_A_CALL_MUTATION } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import GradientButton from '../guest/GradientButton.vue';

  export default {
    name: 'RequestAdvisorCall',
    components: {
      ErrorSnackbar,
      GradientButton,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        requestACallButtonLoading: false,
        errorMessage: null,
      };
    },
    computed: {
      advisor() {
        return this.testator.advisor;
      },
      advisorFirstName() {
        return this.advisor.fullName.split(' ')[0];
      },
      insuranceAlertMessage() {
        return 'Your request has been logged successfully';
      },
      hasAdvisorFullInsurance() {
        return this.testator.enabledFeatures.includes('advisor_full_insurance');
      },
    },
    methods: {
      requestACall() {
        this.requestACallButtonLoading = true;
        this.$apollo
          .mutate({
            mutation: REQUEST_A_CALL_MUTATION,
            variables: {
              testatorId: this.testatorId,
              forInsurance: true,
            },
          })
          .then(response => {
            this.$router.push({
              name: 'OverviewPage',
              params: { insuranceAlertMessage: this.insuranceAlertMessage },
            });
            this.requestACallButtonLoading = false;
          })
          .catch(error => {
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
              this.displayError();
            } else {
              this.displayError();
              throw error;
            }
            this.requestACallButtonLoading = false;
          });
      },
    },
  };
</script>
